module.exports = "<div *ngIf=\"breadcrumblist.length > 0\" class=\"breadcrumb-danubio\">\r\n  <span *ngFor=\"let breadcrumb of breadcrumblist\" >\r\n    <a *ngIf=\"breadcrumb.path != '#'\" [routerLink]=\"breadcrumb.path\">{{breadcrumb.name}} <i class=\"fa fa-caret-right\" aria-hidden=\"true\"></i></a>\r\n    <span *ngIf=\"breadcrumb.path == '#'\" >{{breadcrumb.name}} <i class=\"fa fa-caret-right\" aria-hidden=\"true\"></i></span>\r\n  </span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/breadcrumb/breadcrumb.template.html
// module id = ./src/app/breadcrumb/breadcrumb.template.html
// module chunks = main